import {
    accommodationSubTypeIdFactory,
    accommodationSubTypeIdZodSchema,
} from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-sub-type-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { iconNameZodString } from "@@/shared/icon-name";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";

const accommodationSubTypeZodObject = z.object({
    _id: accommodationSubTypeIdZodSchema,
    _type: z.literal("ACCOMMODATION_SUB_TYPE"),
    _createdAt: isoAndUnixZodSchema,
    _createdBy: userIdZodSchema,
    title: requiredTranslatableZodSchema,
    iconName: iconNameZodString.optional(),
    shortDescription: translatableZodSchema.optional(),
});

type AccommodationSubType = z.infer<typeof accommodationSubTypeZodObject>;

const accommodationSubTypeFactoryParamsZodObject =
    accommodationSubTypeZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type FactoryParams = z.infer<typeof accommodationSubTypeFactoryParamsZodObject>;
const accommodationSubTypeFactory = (
    params: FactoryParams,
): AccommodationSubType => {
    return {
        ...params,
        _id: accommodationSubTypeIdFactory(),
        _type: "ACCOMMODATION_SUB_TYPE",
        _createdAt: nowIsoAndUnix(),
    };
};

export {
    accommodationSubTypeFactory,
    accommodationSubTypeFactoryParamsZodObject,
    accommodationSubTypeZodObject,
};
export type {
    AccommodationSubType,
    FactoryParams as AccommodationSubTypeFactoryParams,
};
